import React, { useEffect, useState } from "react";
import { getIconByName, getName } from "../report-components/report-service/report-menu-service";
import s from "./report-components-menu.module.scss";

const ReportComponentsMenu = (props) => {

    const [elements, setElements] = useState(props.reportComponents ? Object.keys(props.reportComponents) : []);

    useEffect(() => {
        setElements(props.reportComponents ? Object.keys(props.reportComponents) : []);
    }, [props]);

    const addComponent = (type) => {
        props.addComponent(type);
    }

    const reportComponents = elements.map((k, i) => <button key={i} disabled={!props.selectedReportTemplate || props.isReadOnly} className={s.menuItem} onClick={addComponent.bind(this, k)}>{getIconByName(k)}<span>{getName(k)}</span><div></div></button>);
    
    return (
        <div className={s.ReportComponents}>
            
            <div className={s.ReportComponentsMenu}>
                <div className={s.ReportTitle}>{props.getValue('AVAILABLE_COMPONENTS')}</div>
                {reportComponents}
            </div>
            
        </div>
    )
}

export default ReportComponentsMenu;